export const titular = [
    {
        "nombre" : "Edgar Orlando Ángeles Pérez ",
        "imagen" : "https://cdn.hidalgo.gob.mx/gobierno/images/gabinete/OrlandoAngelesPerez.png",
       /*  "imagen" : "https://cdn.hidalgo.gob.mx/gobierno/images/veda/titular_veda.png", */
        "funcion" : ""
    }
]
